import React from "react";
import { useTranslation } from "react-i18next";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import clientImage from "../../../../assets/Home/clinte.jpg";

const Client = () => {
  const { t } = useTranslation();

  const clientImages = Array(6).fill(clientImage);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,  // Adjust the number of slides to show on each screen size
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className=" w-4/5 m-auto my-6">
      <p
        className=" mb-6 text-xl font-medium "
      >
       {t("Common.OUR-VALUABLE-CLIENTS")}
      </p>
      <Slider {...sliderSettings}>
        {clientImages.map((image, id) => (
          <div key={id} className=" flex justify-center   items-center   mb-4">
            <img
              className=" w-32 object-cover"
              src={image}
              alt={`Client Image ${id + 1}`}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Client;
